function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isEmpty from 'ramda/src/isEmpty';
import pathOr from 'ramda/src/pathOr';
import { ADJUSTMENT_CATEGORIES, DEBIT_NOTE, INVOICE, MAX_DESCR_LENGTH, MIN_NOTE_AMOUNT, NOTE_TYPES } from './createNote.modal.constants';
import { constraintErrorMessages } from 'invision-core/src/utilities/angular.form.utilities';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import { CurrentBusinessUnitCurrencyCodeSelector } from 'invision-core/src/components/session/businessunit.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { createConvergentBillerAdjustment, retrieveInvoicesForDropdown } from '../../../reducers/actions/customer.billing.actions';
import * as BillingPaymentsConstants from '../../../components/billingPayments/billing.payments.constants';
import { AdjustmentConfigSelector, AdjustmentReasonCodeValueOptions, HierarchyInvoiceNodeSubscriberIdSelector, InvoiceListForDropDownSelector, InvoiceSummariesSelector, IsFetchingInvoiceListSelector } from '../../../reducers/selectors/customer.billing.selectors';
import { IsCreatingConvergentBillerAdjustmentSelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { ACCOUNTING_METHODS_NAMES } from '../../../reducers/constants/billing.payments.constants';
import { CurrentCustomerAccountingMethodSelector, CurrentCustomerSelector } from '../../../reducers/selectors/customer.selectors';
import { InvEnableAutoApplyNoteToFutureInvoicesSelector } from '../../../reducers/selectors/customer.actions.template.selectors';
import LocaleKeys from '../../../locales/keys';
import moment from 'moment';
import { REPORTING_LEVELS } from '../../../components/customer/accountHierarchy/account.hierarchy.constants';
var CreateNoteModalController = /*#__PURE__*/function () {
  function CreateNoteModalController($ngRedux, $filter, uiNotificationService) {
    _classCallCheck(this, CreateNoteModalController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      formattedInvoiceList: [],
      formattedInvoiceAndDebitNoteList: [],
      invoicesOptions: [],
      isStatement: this.isStatement.bind(this),
      showAutoApplyToFutureInvoices: this.showAutoApplyToFutureInvoices.bind(this),
      MAX_DESCR_LENGTH: MAX_DESCR_LENGTH,
      MIN_NOTE_AMOUNT: MIN_NOTE_AMOUNT,
      NOTE_TYPES: NOTE_TYPES,
      selectedInvoiceOrDebitNote: null,
      selectedReasonCode: null,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(CreateNoteModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentConfig: AdjustmentConfigSelector(store),
          adjustmentReasonCodes: AdjustmentReasonCodeValueOptions(store),
          adjustmentReasonCodesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdjustmentReason, store),
          currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
          isAutoApplyNoteToFutureInvoicesEnabled: InvEnableAutoApplyNoteToFutureInvoicesSelector(store),
          hierarchyInvoiceNodeSubscriberId: HierarchyInvoiceNodeSubscriberIdSelector(store),
          invoiceAndDebitNoteList: InvoiceListForDropDownSelector(store),
          invoiceSummaries: InvoiceSummariesSelector(store),
          isCreatingConvergentBillerAdjustment: IsCreatingConvergentBillerAdjustmentSelector(store),
          isFetchingInvoiceAndDebitNoteList: IsFetchingInvoiceListSelector(store)
        };
      };
      var controllerActions = {
        createConvergentBillerAdjustment: createConvergentBillerAdjustment,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        retrieveInvoicesForDropdown: retrieveInvoicesForDropdown
      };
      this.localeKeys = LocaleKeys;
      this.noteType = NOTE_TYPES.CREDIT;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.adjustmentReasonCodesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.AdjustmentReason);
      }
      if (this.state.invoiceSummaries.length) {
        this.currencyCode = this.state.invoiceSummaries[0].CurrencyCode;
      } else {
        this.currencyCode = this.state.currentBusinessUnitCurrencyCode;
      }
      this.enableGenerateStatements = this.state.adjustmentConfig[BillingPaymentsConstants.ENABLE_GENERATE_STATEMENT] === BillingPaymentsConstants.ADJUSTMENT_CONFIG_ENABLED ? true : false;
      this.autoApplytoFutureInvoices = false;
      this.getInvoiceAndDebitNotesList();
    }
  }, {
    key: "showAutoApplyToFutureInvoices",
    value: function showAutoApplyToFutureInvoices() {
      return this.state.isAutoApplyNoteToFutureInvoicesEnabled && this.state.currentCustomerAccountingMethod !== ACCOUNTING_METHODS_NAMES.BALANCE_FORWARD;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "getInvoiceAndDebitNotesList",
    value: function getInvoiceAndDebitNotesList() {
      var _this2 = this;
      var getInvoiceAndDebitNotesListRequest = {
        customerId: this.state.currentCustomer.Id,
        request: {
          Filter: BillingPaymentsConstants.INVOICES | BillingPaymentsConstants.DEBIT_NOTES
        }
      };
      this.actions.retrieveInvoicesForDropdown(getInvoiceAndDebitNotesListRequest).then(function () {
        _this2.formatInvoiceAndDebitNotesList();
        _this2.setInvoicesOptions();
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "adjustmentReasonCodes",
    get: function get() {
      var _this3 = this;
      var adjustmentReasonCodes = pathOr([], ['adjustmentReasonCodes'], this.state);
      return adjustmentReasonCodes.filter(function (reasonCode) {
        return (reasonCode.adjustment_category === ADJUSTMENT_CATEGORIES.OTHER || isEmpty(reasonCode.adjustment_category)) && (_this3.noteType === reasonCode.adjustment_payment_type || isEmpty(reasonCode.adjustment_payment_type));
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.onClose();
    }
  }, {
    key: "formatInvoiceAndDebitNotesList",
    value: function formatInvoiceAndDebitNotesList() {
      var _this4 = this;
      function isFutureDatedInvoice(invoiceDueDate) {
        return invoiceDueDate && new Date(invoiceDueDate).getTime() > Date.now();
      }
      this.state.invoiceAndDebitNoteList.asMutable({
        deep: true
      }).forEach(function (item) {
        if (item.Invoice && item.Invoice.CurrentDue > 0 && !item.Invoice.IsStatement && isFutureDatedInvoice(item.Invoice.DueDate)) {
          _this4.formattedInvoiceList.push({
            amount: item.Invoice.CurrentDue,
            id: item.Invoice.InvoiceId,
            text: "".concat(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.INVOICE_PREFIX)).concat(item.Invoice.InvoiceNumber, " - ").concat(_this4.$filter('invCurrency')(item.Invoice.CurrentDue, item.Invoice.CurrencyCode), " - ").concat(_this4.$filter('localShortDate')(item.Invoice.DueDate)),
            type: INVOICE
          });
        }
        if (item.Invoice && item.Invoice.CurrentDue > 0 && !item.Invoice.IsStatement) {
          _this4.formattedInvoiceAndDebitNoteList.push({
            amount: item.Invoice.CurrentDue,
            id: item.Invoice.InvoiceId,
            text: "".concat(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.INVOICE_PREFIX)).concat(item.Invoice.InvoiceNumber, " - ").concat(_this4.$filter('invCurrency')(item.Invoice.CurrentDue, item.Invoice.CurrencyCode)),
            type: INVOICE
          });
        }
        if (item.DebitNote && item.DebitNote.RemainingBalance > 0) {
          _this4.formattedInvoiceAndDebitNoteList.push({
            amount: item.DebitNote.RemainingBalance,
            id: item.DebitNote.Id,
            text: "".concat(i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.DEBIT_NOTE_PREFIX)).concat(item.DebitNote.ReferenceId, " - ").concat(_this4.$filter('invCurrency')(item.DebitNote.RemainingBalance, item.DebitNote.CurrencyCode)),
            type: DEBIT_NOTE
          });
        }
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      this.maxNoteAmount = this.noteType === NOTE_TYPES.DEBIT ? null : this.selectedInvoiceOrDebitNote && this.selectedInvoiceOrDebitNote.amount || null;
      this.formErrorMessages = constraintErrorMessages(undefined, this.createNoteForm, {
        noteAmount: LocaleKeys.CREDIT_DEBIT_NOTE.NOTE_AMOUNT,
        noteDescription: LocaleKeys.ADJUSTMENTS.DESCRIPTIONS,
        reasonCode: LocaleKeys.ADJUSTMENTS.REASON_CODE
      }, {
        maxlength: {
          noteDescription: this.MAX_DESCR_LENGTH
        },
        max: {
          noteAmount: this.$filter('invCurrency')(this.maxNoteAmount, this.currencyCode)
        },
        min: {
          noteAmount: this.$filter('invCurrency')(this.MIN_NOTE_AMOUNT, this.currencyCode)
        }
      });
    }
  }, {
    key: "setInvoicesOptions",
    value: function setInvoicesOptions() {
      this.invoicesOptions = this.noteType === NOTE_TYPES.DEBIT ? this.formattedInvoiceList : this.formattedInvoiceAndDebitNoteList;
    }
  }, {
    key: "createNote",
    value: function createNote() {
      var _this5 = this;
      if (this.createNoteForm.$valid) {
        var request = {
          customerId: this.state.currentCustomer.Id,
          request: _objectSpread(_objectSpread({
            AccountNumber: this.accountNumber,
            AdjustmentTypeCode: this.noteType,
            Amount: parseFloat(this.noteAmount).toFixed(2),
            Description: this.noteDescription,
            GenerateStatement: this.enableGenerateStatements
          }, this.showAutoApplyToFutureInvoices() ? {
            AutoApplyToFutureInvoices: this.autoApplytoFutureInvoices
          } : {}), {}, {
            DebitNoteId: this.selectedInvoiceOrDebitNote && this.selectedInvoiceOrDebitNote.type === DEBIT_NOTE ? this.selectedInvoiceOrDebitNote.id : null,
            InvoiceId: this.selectedInvoiceOrDebitNote && this.selectedInvoiceOrDebitNote.type === INVOICE ? this.selectedInvoiceOrDebitNote.id : null,
            PostDate: new Date(),
            ReasonCode: this.selectedReasonCode
          })
        };
        this.actions.createConvergentBillerAdjustment(request).then(function () {
          var successMessage = _this5.noteType === NOTE_TYPES.CREDIT ? i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.CREDIT_NOTE_APPLIED) : i18n.translate(LocaleKeys.CREDIT_DEBIT_NOTE.DEBIT_NOTE_APPLIED);
          _this5.uiNotificationService.transientSuccess(successMessage);
          _this5.onSuccess();
        }).catch(function (error) {
          if (_this5.formErrorMessages) {
            _this5.formErrorMessages.length = 0;
          }
          _this5.formErrorMessages.push(error.translatedMessage);
        });
      } else {
        this.validateForm();
      }
    }
  }, {
    key: "onNoteTypeChange",
    value: function onNoteTypeChange() {
      if (this.noteType === NOTE_TYPES.DEBIT) {
        this.selectedInvoiceOrDebitNote = null;
      }
      this.setInvoicesOptions();
      this.validateForm();
    }
  }, {
    key: "isStatement",
    value: function isStatement() {
      var _this$state$currentCu;
      return ((_this$state$currentCu = this.state.currentCustomer) === null || _this$state$currentCu === void 0 ? void 0 : _this$state$currentCu.HierarchyReportingLevel) === REPORTING_LEVELS.REPORTING_LEVEL_STATEMENT;
    }
  }]);
}();
export default {
  controller: CreateNoteModalController,
  controllerAs: 'CreateNoteModalController',
  template: require('./createNote.modal.html'),
  bindings: {
    accountNumber: '<?',
    config: '<',
    onClose: '&',
    onSuccess: '&'
  }
};